import { MinimalUser, Role } from '../../models/User';

export type MinimalUserProfile = {
    user_id: string;
    username?: string | null;
    image_url?: string | null;
    discord_username?: string | null;
    role?: Role | null;
};

// Supabase generates nullable columns for `user_profiles` even though the schema
// guarantees `username` and `role` are set. Narrow at the boundary and throw if
// the data ever drifts.
export function toMinimalUser(profile: MinimalUserProfile): MinimalUser {
    if (profile.username == null || profile.role == null) {
        throw new Error(`Missing required user_profiles fields for user ${profile.user_id}`);
    }
    return {
        id: profile.user_id,
        username: profile.username,
        avatarUrl: profile.image_url ?? undefined,
        discordUsername: profile.discord_username ?? undefined,
        role: profile.role,
    };
}
